import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import {
  FEETCH_EXTERNAL_ORDERS,
  FETCH_INC_EXTERNAL_ORDER_CUSTOMERS,
} from "./graphql";
import OrdersView from "./OrdersView";

const OrdersViewContainer = ({ source, incOdooProducts, q }) => {
  const { loading, error, data } = useQuery(FEETCH_EXTERNAL_ORDERS, {
    variables: { source },
  });

  const fetchIncExternalOrderCustomers = useQuery(
    FETCH_INC_EXTERNAL_ORDER_CUSTOMERS,
    { variables: { useType: source } },
  );

  const finalLoading = loading || fetchIncExternalOrderCustomers.loading;
  const finalError = error || fetchIncExternalOrderCustomers.error;

  if (finalLoading) return <Spinner />;
  if (finalError) return <Errors error={finalError} />;

  const odooCustomers = JSON.parse(
    fetchIncExternalOrderCustomers.data.odooCustomers,
  ).records;
  console.log("data.externalOrders", data.externalOrders);

  return (
    <OrdersView
      source={source}
      externalOrders={data.externalOrders}
      odooCustomers={odooCustomers}
      incOdooProducts={incOdooProducts}
      q={q}
    />
  );
};

export default OrdersViewContainer;
